<ng-container *transloco="let t">
  <!-- PRODUCT MODE -->
  <nav
    *ngIf="product && !(lessThan$ | async)?.mobileL && !collectionMode"
    [class.rtl]="isRtl$ | async"
    [class.widescreen]="!(lessThan$ | async)?.md"
    class="featured-breadcrumbs">
    <ng-container *ngIf="product.category">
      <a
        class="link"
        [routerLink]="getCategoryCollectionFragment(product.category)"
        [queryParams]="queryParamsToKeep$ | async">
        {{
          t(
            'category_' +
              (capitalizeCategory(product.category)?.toLowerCase() || '') +
              '_title'
          )
        }}
      </a>
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
    </ng-container>
    <ng-container *ngIf="product.model">
      <a
        class="link"
        [routerLink]="getModelCollectionFragment(product.model)"
        [queryParams]="queryParamsToKeep$ | async"
        >{{ product.model }}</a
      >
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
    </ng-container>
    <div class="title-cont">
      <span class="title">{{ product.title }}</span>
    </div>
  </nav>

  <!-- COLLECTION MODE -->
  <span
    class="fixed-space-12"
    *ngIf="!(lessThan$ | async)?.mobileL && collectionMode"
    aria-hidden="true"></span>

  <!-- WITH PRODUCT -->
  <nav
    *ngIf="
      !(lessThan$ | async)?.mobileL && collectionMode && product && !category && !brand
    "
    [class.rtl]="isRtl$ | async"
    [class.widescreen]="!(lessThan$ | async)?.md"
    class="featured-breadcrumbs collection-mode">
    <a
      class="link"
      [routerLink]="getHomeUrl()"
      [queryParams]="queryParamsToKeep$ | async">
      {{ t('title_home') }}
    </a>
    <ng-container *ngIf="product.category as category">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getCategoryCollectionFragment(category)"
        [queryParams]="queryParamsToKeep$ | async">
        {{
          t('category_' + (capitalizeCategory(category)?.toLowerCase() || '') + '_title')
        }}
      </a>
    </ng-container>
    <ng-container *ngIf="product.brand as brand">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getCategoryCollectionFragment(product.category)"
        [queryParams]="getBrandParams(brand)"
        >{{ brand }}</a
      >
    </ng-container>
    <ng-container *ngIf="product.model as model">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getModelCollectionFragment(model)"
        [queryParams]="queryParamsToKeep$ | async"
        >{{ model }}</a
      >
    </ng-container>
  </nav>

  <!-- NO PRODUCT -->

  <nav
    *ngIf="!(lessThan$ | async)?.mobileL && collectionMode && (category || brand)"
    [class.rtl]="isRtl$ | async"
    [class.widescreen]="!(lessThan$ | async)?.md"
    class="featured-breadcrumbs collection-mode">
    <a
      class="link"
      [routerLink]="getHomeUrl()"
      [queryParams]="queryParamsToKeep$ | async">
      {{ t('title_home') }}
    </a>

    <ng-container *ngIf="category">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getCategoryCollectionFragment(category)"
        [queryParams]="queryParamsToKeep$ | async">
        {{
          t('category_' + (capitalizeCategory(category)?.toLowerCase() || '') + '_title')
        }}
      </a>
    </ng-container>
    <ng-container *ngIf="brand">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getBrandCollectionFragment(brand)"
        [queryParams]="queryParamsToKeep$ | async"
        >{{ brand }}</a
      >
    </ng-container>
    <ng-container *ngIf="model">
      <popsy-icon-arrow-right-1 class="icon"></popsy-icon-arrow-right-1>
      <a
        class="link"
        [routerLink]="getModelCollectionFragment(model)"
        [queryParams]="queryParamsToKeep$ | async"
        >{{ model }}</a
      >
    </ng-container>
  </nav>
  <span class="fixed-space-24" aria-hidden="true"></span>
</ng-container>
